import filtersKeys from 'constants/filters';
import { FilterTypes } from 'constants/FilterTypes';
import modes from 'components/ui/buttonsGroup/modes';

const rcsFraud = [
  {
    filterId: filtersKeys.riskProjectIds,
    type: FilterTypes.multiSelect,
    dictionary: 'enabledProjectExternal',
    title: 'risks.quickFilters.project',
  },
  {
    filterId: filtersKeys.risksCreatedAt,
    type: FilterTypes.dateButtons,
    withTime: false,
  },
];

const rcsBlackWhite = [
  [
    {
      filterId: filtersKeys.riskContentType,
      type: FilterTypes.buttonsList,
      valueType: 'string',
      mode: modes.singleRequired,
      list: [
        { id: 'customer', text: 'risks.fraudRegistry.customerID' },
        { id: 'pan', text: 'risks.fraudRegistry.accountNumber' },
        { id: 'email', text: 'risks.bwlist.quickFilters.email' },
        { id: 'ip', text: 'risks.bwlist.quickFilters.ip' },
        { id: 'bin', text: 'risks.bwlist.quickFilters.bin' },
      ],
    },
    {
      filterId: filtersKeys.riskValue,
      type: FilterTypes.multiText,
      separators: [','],
      title: 'risks.quickFilters.value',
    },
  ],
  [
    {
      filterId: filtersKeys.riskListType,
      type: FilterTypes.buttonsList,
      mode: modes.multi,
      list: [
        {
          id: 'whitelist',
          text: 'risks.quickFilters.listType.whitelist.button',
        },
        {
          id: 'blacklist',
          text: 'risks.quickFilters.listType.blacklist.button',
        },
      ],
    },
    {
      filterId: filtersKeys.riskMerchantId,
      type: FilterTypes.select,
      dictionary: 'userMerchant',
      title: 'risks.quickFilters.merchant',
    },
    {
      filterId: filtersKeys.riskProjectIds,
      type: FilterTypes.multiSelect,
      dictionary: 'enabledProjectExternal',
      title: 'risks.quickFilters.project',
    },
    {
      filterId: filtersKeys.risksCreatedAt,
      type: FilterTypes.dateButtons,
      withTime: false,
    },
  ],
];

export default { rcsFraud, rcsBlackWhite };
